<template>
  <main id="password-reset" class="site-main vendor-login">
    <div class="grid-container">
      <div class="text-center" style="margin-bottom: 30px;">
        <a href="/">
          <img v-if="logo && logo.length > 0"
               :src="logo"
               alt="Visceral Apps" style="max-width: 400px;">
        </a>

        <div v-if="description && description.length > 0" v-html="description"
             style="padding-top: 30px;"></div>
      </div>

      <div class="login-form">
        <div class="panel" v-if="validToken !== null && validToken">
          <h2>Reset Your Password</h2>

          <div class="text-left">
            <ul>
              <li><small><i>Your password can't be too similar to your other
                personal information.</i></small>
              </li>
              <li><small><i>Your password must contain at least 8 characters.</i></small>
              </li>
              <li><small><i>Your password can't be a commonly used
                password.</i></small></li>
              <li><small><i>Your password can't be entirely numeric.</i></small>
              </li>
            </ul>

            <div class="form-field">
              <label for="new-password">New Password</label>
              <input id="new-password" name="new-password" type="password">
            </div>

            <div class="form-field">
              <label for="confirm-new-password">Confirm New Password</label>
              <input id="confirm-new-password" name="confirm-new-password"
                     type="password">
            </div>

            <p class="text-success-color text-right"
               v-if="passwordSuccess !== null" v-html="passwordSuccess"></p>

            <p class="text-alert-color text-right"
               v-if="passwordError !== null" v-html="passwordError"></p>

            <button class="button--wide"
                    @click="resetPassword">Reset Pasword</button>

            <div class="text-center" style="padding: 15px;">
              <router-link :to="{name: 'vendorPortalLogin'}">Go to Login</router-link>
            </div>
          </div>
        </div>

        <div class="panel" v-if="validToken !== null && !validToken">
          <p>Password reset link is invalid.</p>

          <div class="text-center" style="padding: 15px;">
            <router-link :to="{name: 'vendorPortalLogin'}">Go to Login</router-link>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import authenticationMixin from '@/mixins/authentication'
import axios from 'axios'
import env from '@/mixins/env'

export default {
  name: 'vendorPortalLogin',
  mixins: [authenticationMixin],
  components: {},
  data: function () {
    return {
      logo: '',
      description: '',
      validToken: null,
      token: null,
      passwordSuccess: null,
      passwordError: null
    }
  },
  methods: {
    resetPassword () {
      let newPasswordElement = document.getElementById('new-password')
      let confirmNewPasswordElement = document.getElementById('confirm-new-password')

      newPasswordElement.style.borderColor = 'transparent'
      confirmNewPasswordElement.style.borderColor = 'transparent'

      if (newPasswordElement.value.length === 0) {
        newPasswordElement.style.borderColor = '#cc4b37'
      }

      if (confirmNewPasswordElement.value.length === 0) {
        confirmNewPasswordElement.style.borderColor = '#cc4b37'
      }

      if (newPasswordElement.value.length === 0 || confirmNewPasswordElement.value.length === 0) {
        this.passwordError = 'Please fill out all fields.'

        return true
      }

      if (newPasswordElement.value !== confirmNewPasswordElement.value) {
        this.passwordError = 'New and confirm passwords do not match.'

        return true
      }

      let data = {
        new_password1: newPasswordElement.value,
        new_password2: confirmNewPasswordElement.value
      }

      let params = env.params().split('&')

      for (let i = 0; i < params.length; i++) {
        let param = params[i].split('=')

        data[param[0]] = param[1]
      }

      this.passwordSuccess = null
      this.passwordError = null

      axios({
        method: 'put',
        url: env.api_url() + '/accounts/reset-password/',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.token
        },
        data: data
      }).then((response) => {
        if (response.status === 200) {
          this.passwordSuccess = 'Password has been reset. Please proceed to login.'
        } else {
          this.passwordError = 'Something went wrong.'
        }
      }).catch(error => {
        if (error) {
          this.passwordError = 'Something went wrong.'
        }
      })
    }
  },
  created () {
    this.logo = this.$store.state.portalSettings.vendor_portal_logo_url
    this.description = this.$store.state.portalSettings.vendor_portal_login_description

    let data = {
      uidb64: this.$route.params.uid,
      token: this.$route.params.token
    }

    axios({
      method: 'put',
      url: env.api_url() + '/accounts/authenticate-token/',
      data: data
    }).then((response) => {
      if (response.status === 200) {
        this.validToken = true
        this.token = response.data.access
      }
    }).catch(error => {
      if (error) {
        this.validToken = false
      }
    })
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

.vendor-login {
  padding: 60px 0;
}

.login-form {
  text-align: center;

  .panel {
    margin: 0 auto;
    max-width: 500px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/vendorPortal/passwordReset.vue